// extracted by mini-css-extract-plugin
export const root = "member-list-module--root--2ZByi";
export const item = "member-list-module--item--bACMy";
export const text = "member-list-module--text--nBAfx";
export const image = "member-list-module--image--86enb";
export const heading = "member-list-module--heading--2OcmE";
export const position = "member-list-module--position--3_bTi";